import React from 'react'
import SbEditable from 'storyblok-react'
import FluidImage from 'src/utils/FluidImage'
import RichText from 'src/utils/RichText'
import Heading from 'src/components/Heading'
import Button from 'src/components/Button'
import GetMagazine from 'src/utils/GetMagazine'
import MagazineItem from './MagazineItem'

const CustomMagazine = ({ blok }) => {

    return (
        <SbEditable content={blok} key={blok._uid}>
            <div className="bg-white mt-16 mb-20 px-6 lg:mt-24 lg:mb-28 lg:px-8">
                <div className="relative max-w-7xl mx-auto divide-y divide-gray-200">
                    {blok.title && blok.description &&
                        <div className="flex lg:flex-row flex-col lg:justify-between lg:items-end gap-y-4">
                            <div>
                                {blok.title && <Heading size="h2" className="text-darkgrey mb-2">{blok.title}</Heading>}
                                {blok.description &&
                                    <div className="text-darkgrey prose text-sm">
                                        <RichText>{blok.description}</RichText>
                                    </div>
                                }
                            </div>
                            {blok.button_text &&
                                <div>
                                    <Button target={`/${blok.button_target.cached_url}`} className="bg-red hover:bg-darkred">{blok.button_text}</Button>
                                </div>
                            }
                        </div>
                    }
                    <div className="mt-6 pt-10 grid gap-12 md:grid-cols-2 lg:gap-x-8 gap-y-12">
                        <div className="relative">
                            <h5 className="lg:text-xl text-lg font-insights-display uppercase mb-6">Latest Issue</h5>
                            <div className="sticky top-32">
                                <FluidImage image={blok.latest_issue_image} className="mb-6 hover:opacity-70 duration-300"/>
                                <h3 className="magazine-title text-darkgrey font-insights-display font-light text-xl lg:text-4xl tracking-[0.01em] mb-4">
                                    <span className="block">{blok.latest_issue_title}</span>
                                    <span className="block font-bold">{blok.latest_issue_title_bold}</span>
                                </h3>
                                <div className="font-insights-body text-darkgrey lg:text-[0.8rem] text-sm prose mb-8">
                                    <RichText>{blok.latest_issue_description}</RichText>
                                </div>
                                {blok.latest_issue_button_text &&
                                    <Button target={blok.latest_issue_button_target.linktype !== 'story' ? blok.latest_issue_button_target.cached_url : `/${blok.latest_issue_button_target.cached_url}`} className="bg-red hover:bg-darkred">{blok.latest_issue_button_text}</Button>
                                }
                            </div>
                        </div>
                        <div className="relative">
                            <h5 className="lg:text-xl text-lg font-insights-display uppercase mb-6">Latest Articles</h5>
                            <div className="grid gap-12 lg:grid-cols-2 lg:gap-x-8 gap-y-12">
                                {GetMagazine(blok.items).map((item, index) => (
                                    <MagazineItem {...item} key={index}/>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </SbEditable>
    )
}

export default CustomMagazine